import React from 'react';

import { Box, Paper, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';

export type InfoRow = {
  label: string;
  value: React.ReactNode;
};

type InfoSectionProps = {
  title: string;
  rows: InfoRow[];
};

export const InfoSection: React.FC<InfoSectionProps> = ({ title, rows }) => (
  <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
    <Box sx={{ px: 2, py: 1, backgroundColor: 'grey.100' }}>
      <Typography variant="subtitle2" color="text.secondary" fontWeight={600}>
        {title}
      </Typography>
    </Box>
    <Table size="small">
      <TableBody>
        {rows.map(({ label, value }) => (
          <TableRow key={label} hover>
            <TableCell
              sx={{
                width: '42%',
                color: 'text.secondary',
                fontWeight: 500,
                py: 1,
                borderBottom: '1px solid',
                borderColor: 'divider',
                verticalAlign: 'top',
              }}
            >
              {label}
            </TableCell>
            <TableCell
              sx={{
                py: 1,
                borderBottom: '1px solid',
                borderColor: 'divider',
                wordBreak: 'break-word',
              }}
            >
              {value ?? '—'}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Paper>
);
